import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission, Print } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Button } from 'components';
import { CleanIcon, ViewIcon, TrashIcon, DownloadExcelIcon } from 'assets/icons';
import { PositionService, SanService, ReportService } from 'services';
import moment from 'moment';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since_filter: '',
	until_filter: '',
	san: '',
	payments: '',
	excel_accredited: '',
	since: '',
	until: '',
	since_payment: '',
	until_payment: ''
}

declare var window: any;

class Positions extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nº de SAN',
			'Fecha de creación',
			'Total puestos ocupados',
			'Total puestos por ocupar',
			'Pagos por posición',
			'Estatus',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		modal_download: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Gestión de Posiciones',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await PositionService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since_filter && moment(this.state.form.since_filter).format('YYYY-MM-DD'),
			until: this.state.form.until_filter && moment(this.state.form.until_filter).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.sanes.rows,
			last_page: res.sanes.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	getColor = (item: any) => {
		let color = Colors.green;

		if (item.verified == Constants.STATUS_PAYMENT.CANCELLED) {
			color = Colors.danger;
		}

		return color;
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el SAN?',async () => {
			await SanService.admin.delete({
				san_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el SAN correctamente");
			this.load(true);
		});
	}

	assignPositions = async (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	changeStatus = async (item: any) => {
		if (item?.status_payment == Constants.STATUS_PAYMENT.PENDING || item?.status_payment == Constants.STATUS_PAYMENT.IN_PROGRESS) {
			let status = '';

			switch(item.status_payment) {
				case Constants.STATUS_PAYMENT.PENDING:
					status = 'En ejecución';
				break;

				case Constants.STATUS_PAYMENT.IN_PROGRESS:
					status = 'Culminado';
				break;
			}

			Globals.confirm(`¿Esta seguro de cambiar el San a estatus "${ status }"? Esta acción no se puede deshacer`,async () => {
				await PositionService.admin.changeStatus({
					san_id: item.id
				});
				this.load(true);
			});
		}
	}

	download = async () => {
		const res: any = await ReportService.admin.getExcelReport({
			accredited: this.state.form.excel_accredited,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			since_payment: this.state.form.since_payment && moment(this.state.form.since_payment).format('YYYY-MM-DD'),
			until_payment: this.state.form.until_payment && moment(this.state.form.until_payment).format('YYYY-MM-DD'),
		});
		this.setState({
			form: {
				...this.state.form,
				excel_accredited: '',
				since: '',
				until: '',
				since_payment: '',
				until_payment: ''
			},
			modal_download: false
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	openModalDownload = () => {
		this.setState({
			modal_download: true
		});
	}

	closeModalDownload = () => {
		this.setState({
			modal_download: false
		});
	}
	
	render() {
		const { visible, modal_download } = this.state;

		return (
			<div id="admin-positions">
				<Modal
		          className="modal-view-positions"
		          visible={ visible }
		          title="Posiciones"
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalView
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-positions-excel"
		          visible={ modal_download }
		          title="Descargar Excel"
		          onClose={ () => this.closeModalDownload() }
		        >
		        	<div id="modal-positions-excel">
		        		<Select
							placeholder="Ambos"
							label="Acreditación"
							name="excel_accredited"
							color="white"
							onChange={ (e: any) => this.change(e) }
							value={ this.state.form.excel_accredited }
							options={ [
								{ value: Constants.ACCREDITED.YES.toString() , label: 'Acreditados' },
								{ value: Constants.ACCREDITED.NO.toString() , label: 'No acreditados' },
							] } />
						<div className="row">
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										});
									} }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										});
									} }
									value={ this.state.form.until }
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Desde (Pago)"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since_payment'
											}
										});
									} }
									value={ this.state.form.since_payment }
								/>
							</div>
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Hasta (Pago)"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until_payment'
											}
										});
									} }
									value={ this.state.form.until_payment }
								/>
							</div>
						</div>
		        		<div className="text-center">
							<Button type="submit" onClick={ () => this.download() }>
								Descargar
							</Button>
						</div>
		        	</div>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="row col-md-10">
								<div className="col-md">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Nombre usuario"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										showYearDropdown={ true }
										label="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since_filter'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since_filter }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										showYearDropdown={ true }
										label="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until_filter'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until_filter }
									/>
								</div>
								<div className="col-md">
									<Input
										value={ this.state.form.san }
										name="san"
										placeholder="Buscar"
										label="Nº de SAN"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<Input
										type="number"
										value={ this.state.form.payments }
										name="payments"
										placeholder="Buscar"
										label="Pagos por posición"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Gestión de posiciones" data={ this.state.data.length } header={ this.state.header } titleRight={
					<React.Fragment>
						{
							this.state.data.length > 0 && (
								<div className="container-add-table">
									<p>Descargar Excel</p>
									<button className="btn add-btn-table" onClick={ this.openModalDownload }>
										<img src={ DownloadExcelIcon } />
									</button>
								</div>
							)
						}
					</React.Fragment>
				}>
					{ this.state.data.map((i: any,index: number) => {
						const show_assign = i.positions?.filter((i: any) => i.position == null).length > 0 || i.quantity_persons > i.positions?.length;

						let san_pending = i.quantity_persons - i.positions?.length;

						if (san_pending < 0) {
							san_pending = 0;
						}

						const link_active = i?.status_payment == Constants.STATUS_PAYMENT.PENDING || i?.status_payment == Constants.STATUS_PAYMENT.IN_PROGRESS;

						return (
							<tr key={ index }>
								<td>{ i.code }</td>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i.positions?.length }</td>
								<td>{ san_pending }</td>
								<td>{ i.type_id == Constants.SAN_TYPES.PREMIUM ? i.positions?.filter((i: any) => Constants.IMPORTANT_POSITIONS.indexOf(i.position) != -1)?.length : 0 }</td>
								<td className="status" onClick={ () => this.changeStatus(i) } style={{
									color: this.getColor(i),
									cursor: link_active ? 'pointer' : 'default'
								}}>{ i.status_payment_text }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									{
										i.status_payment == Constants.STATUS_PAYMENT.FINISH && (
											<>
												{
													checkPermission(Constants.MODULES.POSITIONS,'delete') && (
														<Tooltip title="Eliminar">
															<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
																<img src={ TrashIcon } />
															</a>
														</Tooltip>
													)
												}
											</>
										)
									}
									{
										show_assign ? (
											<a className="link-icon link-assign" href="#" onClick={ (e: any) => this.assignPositions(e,i) }>
												{
													checkPermission(Constants.MODULES.POSITIONS,'write') ? (
														<>Asignar posiciones</>
													) : (
														<>Ver posiciones</>
													)
												}
											</a>
										) : (
											<Tooltip title={ checkPermission(Constants.MODULES.POSITIONS,'write') ? `Asignar posiciones` : 'Ver posiciones' }>
												<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
													<img src={ ViewIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Positions);